import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/carta-gestion.webp")